import { lazy, Suspense } from 'react';
import { redirect, RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { GenerativeAIRouteEnum } from '~/router/@types';

const GenerativeAIPage = lazy(() => import('~/pages/GenerativeAI'));

export const GENERATIVE_AI_ROUTES: RouteObject[] = [
  {
    index: true,
    loader: async () => {
      // 기본적으로 Detected 탭으로 리다이렉트
      return redirect(`${GenerativeAIRouteEnum.Detected}`);
    },
  },
  {
    path: ':tab/:listingId?',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <GenerativeAIPage />
      </Suspense>
    ),
  },
];
